var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "L_building",
    transform: "translate(-732 -608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_806",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(732 608)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    transform: "translate(782 638.627)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    width: 72,
    height: 148,
    className: "cls-2",
    rx: 12.449,
    transform: "translate(0 .373)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(25.563 128.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.107 66.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.019 66.993)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.107 94.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.019 94.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.107 39.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.019 39.491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.107 12.693)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.019 12.693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLBuilding);
export default __webpack_public_path__ + "static/media/l-building.0a3afe347a5a78aa28b678d7069f808a.svg";
export { ForwardRef as ReactComponent };